import React from 'react';
import {Card, Space, Typography} from 'antd';
import {LinkOutlined} from '@ant-design/icons';

const { Title, Paragraph } = Typography;

const About: React.FC = () => {
  const systemTitle = (window as any).systemTitle || "敖武的图床";
  
  return (
    <div className="about-page" style={{ padding: '24px' }}>
      <Card>
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <Title level={2}>关于{systemTitle}</Title>
          
          <div>
            <Title level={3}>功能特性</Title>
            <Paragraph>
              • 图片上传和管理<br/>
              • 批量操作支持<br/>
              • 实时监控系统<br/>
              • 响应式设计<br/>
              • 多页面路由支持
            </Paragraph>
          </div>

          <div>
            <Title level={3}>技术栈</Title>
            <Paragraph>
              • React 18 + TypeScript<br/>
              • Ant Design UI 组件库<br/>
              • React Router 路由管理<br/>
              • 腾讯云 COS 存储服务<br/>
              • Axios 网络请求
            </Paragraph>
          </div>

          <div>
            <Title level={3}>相关链接</Title>
            <Paragraph>
              <Space direction="vertical" size="small">
                <a 
                  href="https://www.yuque.com/aowufudongdong/kb/doa7yc25suqyq5y2" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                >
                  <LinkOutlined />
                  {systemTitle}使用指南
                </a>
                <a 
                  href="https://www.yuque.com/aowufudongdong/kb/nlg8gih5hrv2tv3c" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                >
                  <LinkOutlined />
                  系统配置说明文档
                </a>
                <a 
                  href="https://www.yuque.com/aowufudongdong/kb/og9axmho8yc8w71c" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                >
                  <LinkOutlined />
                  常见问题解答
                </a>
              </Space>
            </Paragraph>
          </div>

          <div>
            <Title level={3}>版本信息</Title>
            <Paragraph>
              当前版本: v0.1.0<br/>
              最后更新: 2024年
            </Paragraph>
          </div>
        </Space>
      </Card>
    </div>
  );
};

export default About; 